








































































import { Component, Vue } from "vue-property-decorator";
import AppHeader from "./AppHeader.vue";
import ErrorAlert from "@/components/ErrorAlert.vue";
import IconLogo from "@/components/IconLogo.vue";

@Component({
  components: {
    AppHeader,
    ErrorAlert,
    IconLogo
  }
})
export default class SignUpPage extends Vue {
  name: string = "";
  email: string = "";
  password: string = "";
  passwordConfirmation: string = "";

  errors: string[] = [];

  // 元々アクセスしようとしていたページ
  get destination(): string {
    if (this.$route.query.destination) {
      return this.$route.query.destination as string;
    } else {
      return "/";
    }
  }

  confirmPassword() {
    const i = this.$refs.password as HTMLInputElement;
    if (this.password === this.passwordConfirmation) {
      i.setCustomValidity("");
    } else {
      i.setCustomValidity("確認用のパスワードが一致しません。");
    }
  }

  async submit(e: Event) {
    this.errors = [];
    const data = new FormData(e.target as HTMLFormElement);
    try {
      await this.$store.dispatch("signUp", data);
    } catch (e) {
      this.errors = e;
      return;
    }
    // サインアップしたばかりだとServiceがわからない
    await this.$store.dispatch("signIn", {
      email: this.email,
      password: this.password
    });
    this.$router.push(this.destination);
  }
}
